'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'beer-mug-empty';
var width = 576;
var height = 512;
var aliases = ["beer"];
var unicode = 'f0fc';
var svgPathData = 'M400 80l0 271.5c0 .3 0 .7 0 1l0 79.5-288 0 0-352 288 0zm48 352l0-65.2 128-64 0-206.8-128 0 0-64-384 0 0 448 384 0 0-48zm80-158.8l-80 40 0-169.2 80 0 0 129.2zM180 128c-11 0-20 9-20 20l0 216c0 11 9 20 20 20s20-9 20-20l0-216c0-11-9-20-20-20zm76 0c-11 0-20 9-20 20l0 216c0 11 9 20 20 20s20-9 20-20l0-216c0-11-9-20-20-20zm96 20c0-11-9-20-20-20s-20 9-20 20l0 216c0 11 9 20 20 20s20-9 20-20l0-216z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBeerMugEmpty = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;